module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var _uuid = Math.floor(Math.random() * 9999999) + '-' + content_id;

    ; __append("\n<article class=\"grid-view-item\">\n    <a class=\"link vilynx-redirect ")
    ; __append(escapeFn( lockLevel !== 'none' ? lockLevel :'' ))
    ; __append("\"\n       vilynx-id=\"")
    ; __append(escapeFn( content_id ))
    ; __append("\"\n       href=\"")
    ; __append(escapeFn( url ))
    ; __append("\"\n       aa-link=\"")
    ; __append(escapeFn( aaLink ))
    ; __append("\"\n       data-tracking=\"")
    ; __append(escapeFn( dataTracking ))
    ; __append("\">\n\n        <div class=\"thumb-wrapper\">\n\n            <img class=\"thumb lazy\" data-src=\"")
    ; __append(escapeFn( thumbUrl ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( series_title ))
    ; __append(" - ")
    ; __append(escapeFn( episode_title ))
    ; __append("\"/>\n\n            ")
    ; __append("\n            ")
    ;  if (typeof ratingIcon !== 'undefined'){ 
    ; __append("\n                <img class=\"ratings-icon lazy\" data-src=\"")
    ; __append(escapeFn( ratingIcon ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( ratingText ))
    ; __append("\" />\n            ")
    ;  } 
    ; __append("\n\n            ")
    ; __append("\n            ")
    ;  if(typeof progress !== 'undefined' && progress > 0){ 
    ; __append("\n            ")
    ; (function(){
    ; __append("\n")
    ; __append("\n")
    ; __append("\n")
    ; __append("\n\n<style>\n\n    #progress-bar-")
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.25);\n    }\n\n    #progress-bar-")
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #0037C5, #0064FF);\n        background-image: linear-gradient(135deg, #0037C5, #0064FF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; }).call(this)
    ; __append("\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if(lockLevel === 'subscribe' && status !== 'AVAILABLE') { 
    ; __append("\n                <div class=\"subscribe-gradient\"></div>\n                <span class=\"label subscribe\">Subscribe</span>\n            ")
    ;  } else if(lockLevel === 'showtimelock' || lockLevel === 'tvelock') { 
    ; __append("\n                <span class=\"label bundle-lock\">\n                    <img src=\"/assets/images/svg/content_lock.svg\"/>\n                </span>\n            ")
    ;  }else { 
    ; __append("\n            <div class=\"play label circle-sm\">\n                <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                     xmlns=\"http://www.w3.org/2000/svg\">\n                    <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\"\n                            fill=\"none\" cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                </svg>\n            </div>\n            ")
    ;  } 
    ; __append("\n        </div>\n\n\n    <div class=\"info-wrapper\">\n\n        ")
    ;  if(jQuery.inArray("Seasonless", videoProperties) !== -1){
                noSeasons = true;
            }
        
    ; __append("\n\n        ")
    ;  if(jQuery.inArray("Episodeless", videoProperties) !== -1){
                noEpisodes = true;
        }
        
    ; __append("\n\n\n        ")
    ;  if(episode_number != null && episode_number != '' && type !== 'Clip'){ 
    ; __append("\n            ")
    ;  if( typeof noSeasons == 'undefined'){ 
    ; __append("\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Season ")
    ; __append(escapeFn( season_number ))
    ; __append("\" title=\"")
    ; __append(escapeFn( seasonTitle ))
    ; __append("\">\n                    ")
    ; __append(escapeFn( seasonAbbr ))
    ; __append("\n                    </abbr>\n                </span>\n             ")
    ;  } 
    ; __append("\n            ")
    ;  if( typeof noEpisodes == 'undefined'){ 
    ; __append("\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Episode ")
    ; __append(escapeFn( episode_number ))
    ; __append("\" title=\"")
    ; __append(escapeFn( episodeNumberTitle ))
    ; __append("\">\n                    ")
    ; __append(escapeFn( episodeAbbr ))
    ; __append("\n                    </abbr>\n                </span>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if( typeof noSeasons == 'undefined' && typeof noEpisodes == 'undefined' ){ 
    ; __append("\n                    <span class=\"meta-gray meta-airdate\">\n             ")
    ;  }else{ 
    ; __append("\n                    <span class=\"meta-gray\">\n             ")
    ;  } 
    ; __append("\n                        <time datetime=\"")
    ; __append(escapeFn( airdate_iso ))
    ; __append("\">\n                            ")
    ; __append(escapeFn( airdate ))
    ; __append("\n                        </time>\n                    </span>\n            ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(type === 'Clip') { 
    ; __append("\n        <span class=\"meta-gray\" itemprop=\"duration\" content=\"")
    ; __append(escapeFn( duration ))
    ; __append("\">\n                ")
    ; __append(escapeFn( duration ))
    ; __append("\n        </span>\n        ")
    ;  } 
    ; __append("\n\n        ")
    ; __append("\n        ")
    ;  if(displayTitle){ 
    ; __append("\n        <div class=\"title-wrapper\">\n            <span class=\"title\">\n                ")
    ; __append(escapeFn( displayTitle ))
    ; __append("\n            </span>\n        </div>\n        ")
    ;  } 
    ; __append("\n\n    </div>\n    </a>\n</article>\n")
  }
  return __output;

}